import React from "react";
import "./Legal.css";
import SEO from "../../Components/SEO";

function ShippingPolicy() {
  return (
    <>
      <SEO title="Shipping Policy" description="Lutology Shipping Policy" />
      <main
        className="legal-page"
        role="main"
        aria-label="Lutology Shipping Policy"
      >
        <h1>Shipping Policy</h1>
        <p className="legal-meta">Last updated: July 2026</p>

        <p>
          This Shipping Policy explains how we handle orders placed through the
          Lutology™ website.
        </p>

        <h2>1. Processing Time</h2>
        <p>
          Most orders are processed within 1–3 business days. United States
          orders are usually fulfilled through Amazon or other fulfillment
          partners when available.
        </p>

        <h2>2. Shipping Availability</h2>
        <p>
  Shipping availability depends on the destination country and the options
  shown at checkout. If shipping is unavailable to your country at checkout,
  please contact us.
        </p>

        <h2>3. Shipping Costs</h2>
        <p>
          Shipping costs are shown at checkout before payment. Where free
          shipping is available, it will be clearly shown during checkout.
        </p>

        <h2>4. Estimated Delivery Times</h2>
        <p>
          Estimated delivery times depend on the destination and fulfillment
          method. The available shipping options and estimated delivery timeframe
          are shown at checkout before payment.
        </p>

        <h2>5. Tracking</h2>
        <p>Tracking is provided when available.</p>

        <h2>6. Customs & Taxes</h2>
        <p>
          Import duties or taxes are the customer’s responsibility and vary by
          country.
        </p>

        <h2>7. Delays & Lost Packages</h2>
        <p>
          If your package is significantly delayed or appears to be lost, please{" "}
          <a href="/contact" className="legal-link">
            contact us
          </a>
          . We will review the order and may offer a replacement shipment or a
          refund, depending on the situation.
        </p>

        <h2>8. Damaged Items</h2>
        <p>
          If your order arrives damaged, please contact us with photos to
          arrange a replacement or refund.
        </p>

        <h2>9. Address Accuracy</h2>
        <p>
          Customers are responsible for providing a complete and accurate
          shipping address.
        </p>

        <h2>10. Contact</h2>
        <p>
          For shipping questions, please{" "}
          <a href="/contact" className="legal-link">
            reach out via our Contact page
          </a>
          .
        </p>
      </main>
    </>
  );
}

export default ShippingPolicy;